/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean } from './common-D-vggmh2.js';

const validateMultiple = (component, value, options) => {
    watchBoolean(component, '_multiple', value, options);
};

export { validateMultiple as v };
//# sourceMappingURL=multiple-BZRAazRb.js.map

//# sourceMappingURL=multiple-BZRAazRb.js.map